import React from "react";
import { featuredEpisode } from "../mock";
import { Bell } from "lucide-react";
import NewsletterDialog from "./NewsletterDialog";
import useReveal from "../hooks/useReveal";

const FeaturedEpisode = () => {
  const [ref, visible] = useReveal();

  return (
    <section id="episodes" data-testid="featured-episode-coming-soon" className="bg-[#d8d6d0] pb-20 md:pb-28 pt-4">
      <div
        ref={ref}
        className={`max-w-[1300px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10 md:gap-16 items-center reveal ${
          visible ? "is-visible" : ""
        }`}
      >
        <div className="relative w-full aspect-video overflow-hidden rounded-md bg-neutral-800 shadow-xl">
          <img
            src={featuredEpisode.thumbnail}
            alt="The 20 PROOF podcast — coming soon"
            className="w-full h-full object-cover scale-125 blur-[28px] grayscale"
          />
          <div className="absolute inset-0 bg-neutral-700/55" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
            <span className="font-sans-ui uppercase tracking-[0.3em] text-xs md:text-sm">The Podcast</span>
            <span className="font-display text-4xl md:text-6xl mt-2" style={{ fontWeight: 700 }}>
              Coming Soon
            </span>
          </div>
        </div>

        <div>
          <p className="font-sans-ui uppercase tracking-[0.2em] text-sm text-neutral-500">Episode 1</p>
          <h3 className="font-display text-3xl md:text-4xl text-neutral-900 leading-tight mt-2" style={{ fontWeight: 700 }}>
            Coming soon
            <span className="block italic font-normal text-neutral-700 text-2xl md:text-3xl mt-1">
              honest conversations, on the way
            </span>
          </h3>
          <p className="font-display text-neutral-600 text-lg leading-relaxed mt-6">
            Real talk about money, work, love, and the messy art of growing up in your 20s. Be the first to know when the first episode drops.
          </p>
          <NewsletterDialog
            trigger={
              <button
                data-testid="featured-episode-notify-btn"
                className="mt-8 inline-flex items-center gap-2 bg-neutral-900 hover:bg-neutral-700 text-white font-sans-ui text-[15px] px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.03]"
              >
                <Bell size={16} />
                Get notified
              </button>
            }
          />
        </div>
      </div>
    </section>
  );
};

export default FeaturedEpisode;
